import Vue from "vue";
import Vuex from "vuex";
import service from "../../services/workflow/process";
import processW from "../../models/workflow/processW";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service: new service(),
    process: [],
    new: [],
    edit: [],
    deleteItem: [],
    showAdd: false,
    showSteps: false,
    editItems: {},
    concept: [],
    conceptLic: [],
    validations:[],
    typeProcess: [
      {name:"Cambio de horario",value:"CHOR"},
      {name:"Pedido de Licencia",value:"LICE"},
      {name:"Autorización de Extras",value:"HSEX"},
      {name:"Fichada en Licencia",value:"LICF"},
      {name:"Delegación de mando",value:"DELE"},
],
  },

  mutations: {
    setProcess(state, data) {
      state.process = data;
    },

    setEdit(state, data) {
      state.edit = data;
    },

    setDeleteItem(state, data) {
      state.deleteItem = data;
    },
    setShowAdd(state, data) {
      state.showAdd = data;
    },
    setIsEdit(state, data) {
      state.isEdit = data;
    },
    setNew(state, data) {
      state.new = data;
    },
    setShowSteps(state, data) {
      state.showSteps = data;
    },
    setEditItems(state, data) {
      state.editItems = data;
    },
    setConcept(state, data) {
      state.concept = data;
    },
    setConceptLic(state, data) {
      state.conceptLic = data;
    },
    setValidation(state,data){
        state.validations = data
    },
  },
  actions: {
    async getProcess(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getProcess();

          state.commit("setProcess", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async getValidateProcess(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getValidateProcess();
          state.commit("setValidation", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
   
    async getConcept(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getConcepts();

          state.commit("setConcept", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async getConceptLic(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getConceptsLic();

          state.commit("setConceptLic", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    
    async new(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.new(state.state.new).then((data) => {
            let item = state.state.new;
            let options = state.state.process;
            let newItem = processW.fromJson({
              procesoId:data.data.id,
              nombre:item.name,
              descripcion:item.description,
              tipo:item.type,
              conceptoId:item.concept,
            });
            options.push(newItem);
            state.commit("setProcess", options);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    async delete(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.delete(state.state.deleteItem).then(() => {
            let options = state.state.process;
            options = options.filter((option) => {
              return option.id != state.state.deleteItem;
            });
            state.commit("setProcess", options);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    async edit(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.edit(state.state.edit).then(() => {
            let item = state.state.edit
           
            state.commit('setEdit', item)
            resolve(true)
          })
        }
        catch (error) {
          reject(error)
        }
      })

    },
  },
});
